import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@lmc-env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoanInterviewService {
  private readonly uri: string = `${environment.DO_URL}/v2`;
  private http = inject(HttpClient);

  constructor() { }

  checkDuplicateLoan(data:any): Observable<any>  {
	return this.http.post(`${this.uri}/checkDuplicateLoan`, { data });
	}

  addLoanInterviewlocal(
		something: any,
		recordID: any,
		id: any,
		interviewID: any,
		type: any,
		additional: any,
		tdsr: any,
		loggedName: any
	): Observable<any> {
		const data = {
			info: something,
			zohoRecordID: recordID,
			underwritingID: id,
			createdBy: interviewID,
			appType: type,
			totalAdditional: additional,
			tdsr: tdsr,
			loggedName: loggedName,
		};
		return this.http.post(`${this.uri}/addLoanInterviewlocal`, data);
	}

	insertLoanInterviewNotes(
		something: any,
		id: any,
		interviewID: any,
		appName: any,
		interviewer: any
	): Observable<any> {
		const data = {
			info: something,
			zohoRecordID: id,
			interviewerZohoID: interviewID,
			dealName: appName,
			createdBy: interviewer,
		};
		return this.http.post(`${this.uri}/insertLoanInterviewNotes`, data);
	}

}
